import { createSelector } from 'reselect';
const getState = state => state.userCanGdprDeleteSelf;
export const getAllSingleSuperAdminHubs = createSelector([getState], state => state.get('singleSuperAdminHubs'));